import React from "react";
import { connect } from "react-redux";
import { Header, Icon as SemanticIcon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ReimbursementTable from "../../components/ReimbursementTable";
import * as moment from "moment";
import _ from "lodash";

import SubmitterEditForm from "../../components/forms/SubmitterEditForm";

import { backendPhoneNumberToDisplay } from "../../util/phone";

const reimbursementURL = reimbursement =>
  "/_/reimbursement/" + reimbursement.uuid + "/" + reimbursement.modify_key;

const emptyHelpText = submitter => {
  if (submitter.is_phone_confirmed) {
    return (
      <span>
        No reimbursements to show.<br />
        <br />Submit reimbursements by emailing receipt images to{" "}
        <a href="mailto:receipts@spoutmoney.com">receipts@spoutmoney.com</a>, or
        by texting images to <a href="sms:+16175002085">(617) 500-2085</a>. Make
        sure to send from{" "}
        <a href={"mailto:" + submitter.email}>{submitter.email}</a> or{" "}
        <a href={"sms:" + submitter.phone}>
          {backendPhoneNumberToDisplay(submitter.phone)}
        </a>{" "}
        so we know it's you!
      </span>
    );
  } else if (submitter.phone) {
    return (
      <span>
        No reimbursements to show.<br />
        <br />Submit reimbursements by emailing receipt images to{" "}
        <a href="mailto:receipts@spoutmoney.com">receipts@spoutmoney.com</a>.
        Additionally, once your phone is confirmed, you can text images to{" "}
        <a href="sms:+16175002085">(617) 500-2085</a>. Make sure to send from{" "}
        <a href={"mailto:" + submitter.email}>{submitter.email}</a> so we know
        it's you!
      </span>
    );
  } else {
    return (
      <span>
        No reimbursements to show.<br />
        <br />Submit reimbursements by emailing receipt images to{" "}
        <a href="mailto:receipts@spoutmoney.com">receipts@spoutmoney.com</a>.
        Make sure to send from{" "}
        <a href={"mailto:" + submitter.email}>{submitter.email}</a> so we know
        it's you!
      </span>
    );
  }
};

const SubmitterView = props => {
  const reimbursements = _.sortBy(
    props.submitter.reimbursements,
    reimbursement => {
      return -+moment(
        reimbursement.last_action_at || reimbursement.received_at
      );
    }
  );

  return (
    <div>
      <Header as="h2" dividing>
        <SemanticIcon name="user" />
        <Header.Content>
          {props.submitter.name || props.submitter.email}
          <Header.Subheader>
            {props.submitter.name
              ? "Update your profile."
              : "Complete your profile."}
          </Header.Subheader>
        </Header.Content>
      </Header>
      <SubmitterEditForm />
      {props.submitter.is_email_confirmed && (
        <div>
          <Header as="h2" dividing>
            <SemanticIcon name="clipboard check" />
            <Header.Content>Reimbursements</Header.Content>
          </Header>
          <ReimbursementTable
            reimbursements={reimbursements}
            noModal={true}
            noName={true}
            submitter={props.submitter}
            clickAction={reimbursement =>
              props.history.push(reimbursementURL(reimbursement))
            }
            emptyText={emptyHelpText(props.submitter)}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  submitter: state.unauthenticated.submitter
});

export default withRouter(connect(mapStateToProps)(SubmitterView));



// WEBPACK FOOTER //
// ./frontend/src/views/unauthenticated/SubmitterView.js